import React from 'react';
import { PROVIDER_LABELS, PROVIDER_COLORS } from './AdminUsersPage.helpers';

const td = { padding: '10px', verticalAlign: 'middle' };

// One account row in the admin-users table. Toggle/delete are confirmed by the
// parent via ConfirmDialog (onToggle/onDelete set the parent's pending state).
export default function AdminUserRow({ user: u, multi, busy, isSelf, onToggle, onDelete }) {
  const blockSelfRevoke = isSelf && u.isAdmin;
  const isBusy = busy === u.sub;
  return (
    <tr style={{
      borderBottom: '1px solid var(--border)',
      background: isSelf ? '#e3f2fd' : (multi ? '#fffdf5' : 'transparent'),
    }}>
      <td style={{ ...td, minWidth: 180 }}>
        <div style={{ fontWeight: 500 }}>
          {u.email || <span style={{ color: '#aaa' }}>이메일 미동의</span>}
          {isSelf && <span style={{ marginLeft: 6, fontSize: '0.75rem', color: '#1976d2' }}>(나)</span>}
        </div>
        <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>{u.name || '-'}</div>
      </td>
      <td style={td}>
        <span style={{
          display: 'inline-block', padding: '2px 8px', borderRadius: 10,
          background: PROVIDER_COLORS[u.provider] || '#aaa',
          color: u.provider === 'kakao' ? '#000' : '#fff', fontSize: '0.75rem',
        }}>
          {PROVIDER_LABELS[u.provider] || u.provider}
        </span>
      </td>
      <td style={{ ...td, fontSize: '0.85rem', color: 'var(--text-muted)' }}>{u.phoneNumber || '-'}</td>
      <td style={{ ...td, fontSize: '0.8rem', color: 'var(--text-muted)' }}>
        {u.createdAt ? new Date(u.createdAt).toISOString().slice(0, 10) : '-'}
      </td>
      <td style={{ ...td, textAlign: 'center' }}>
        {u.isAdmin
          ? <span style={{ color: '#ff9800', fontWeight: 600 }}>★ 관리자</span>
          : <span style={{ color: 'var(--text-muted)' }}>일반</span>}
      </td>
      <td style={{ ...td, textAlign: 'right', whiteSpace: 'nowrap' }}>
        <button
          onClick={() => onToggle(u)}
          disabled={isBusy || blockSelfRevoke}
          title={blockSelfRevoke ? '자기 자신의 관리자 권한은 해제할 수 없습니다 (락아웃 방지)' : ''}
          style={{
            padding: '6px 12px', fontSize: '0.85rem',
            cursor: blockSelfRevoke ? 'not-allowed' : 'pointer',
            border: 'none', borderRadius: 4, marginRight: 6,
            background: blockSelfRevoke ? '#f5f5f5' : (u.isAdmin ? '#ffebee' : '#e8f5e9'),
            color: blockSelfRevoke ? '#aaa' : (u.isAdmin ? '#c62828' : '#2e7d32'),
            opacity: isBusy ? 0.5 : 1,
          }}
        >
          {isBusy ? '...' : (u.isAdmin ? '권한 해제' : '권한 부여')}
        </button>
        <button
          onClick={() => onDelete(u)}
          disabled={isBusy || isSelf}
          title={isSelf ? '자기 자신은 삭제할 수 없습니다' : '계정 삭제'}
          style={{
            padding: '6px 10px', fontSize: '0.85rem', cursor: isSelf ? 'not-allowed' : 'pointer',
            border: 'none', borderRadius: 4,
            background: isSelf ? '#f5f5f5' : '#fce4ec',
            color: isSelf ? '#aaa' : '#ad1457',
            opacity: isBusy ? 0.5 : 1,
          }}
        >
          🗑 삭제
        </button>
      </td>
    </tr>
  );
}
